import { useTranslation } from 'react-i18next';
import { getDatePickerLocaleText } from 'src/locales/libraryLocales';

const useGetLocaleTextDatePicker = () => {
  const { i18n } = useTranslation();
  return getDatePickerLocaleText(i18n.language);
};

export default useGetLocaleTextDatePicker;
